module.exports = __webpack_public_path__ + "components/media-kit/static/icon-europe-a9b14873361a27b22a486b4a4b9e348a.svg";